module.exports = __webpack_public_path__ + "img/aInvisible.e7a76422.png";